import { integer } from "@-/dev.improve.haniverse.lib.database.table";
import {
  sqliteTable,
  type SQLiteTableExtraConfigValue,
} from "@-/com.npmjs.drizzle-orm/sqlite-core";
import type { BuildColumns, ColumnBuilderBase } from "@-/com.npmjs.drizzle-orm";

import type { LowercaseDatabaseName } from "@-/dev.improve.haniverse.lib.database.table";

const common = {
  id: integer("id").primaryKey(),
} as const;

// Static info data lives in its own SQLite file (`static.db`) opened via a
// dedicated connection — see `database/static`. It is therefore NOT bound to any
// drizzle `Symbol.for("drizzle:Schema")` alias; SQL emitted for these tables uses
// the bare table name. This avoids depending on SQLite's ATTACH DATABASE feature,
// which keeps the data portable to backends like Cloudflare D1 that don't support it.
export function staticTable<const Name extends string, T extends Record<string, ColumnBuilderBase>>(
  name: LowercaseDatabaseName<Name>,
  schema: T,
  extraConfig?: (
    self: BuildColumns<Name, typeof common & T, "sqlite">,
  ) => SQLiteTableExtraConfigValue[],
) {
  return sqliteTable(name, { ...common, ...schema }, extraConfig);
}
